module.exports = __webpack_public_path__ + "8d0627c73b51135855f00fcb99a72dd5.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icon-email.svg
// module id = o8E0
// module chunks = 0